import {ChallengeMode} from "../../../schema";
import {PlayerReduxState, UserInputDisplayMode} from "../types";
import isRecognizing from "./isRecognizing";
import isErrorState from "./isErrorState";
import isIntroStage from "./isIntroStage";
import getCurrentActionDisplayMode from "./getCurrentActionDisplayMode";
import getChallenge from "./getChallenge";

export default function canSkip(state: PlayerReduxState): boolean {
  if (isRecognizing(state) || isErrorState(state) || isIntroStage(state)) {
    return false;
  }
  if (getCurrentActionDisplayMode(state) === UserInputDisplayMode.HINT_TEXT) {
    return false;
  }
  const challenge = getChallenge(state);
  if (challenge?.mode === ChallengeMode.RPG_MODE) {
    return false;
  }
  return true;
}
